<template>
	<el-tooltip placement="top"
				:content="statusTooltip"
				:open-delay="500"
				:disabled="!statusTooltip"
	>
		<div class="status_box" :class="{pointer: withClick }" @click="click">
			<span class="progress_icon" v-if="statusCode === paymentProgress.statusOptions.willBeFullyPaid.code">
				<i class="fa fa-clock-o valid_color" aria-hidden="true"></i>
			</span>
			<span v-else :class="`progress_span progress_${statusCode}`"></span>
		</div>
	</el-tooltip>
</template>

<script>
import {paymentProgress} from "@/common/utils/paymentProgress";

export default {
	props: {
		statusCode: { type: String },
		statusTooltip: { type: String },
		withClick: { type: Boolean, default: false }
	},
	data() {
		return {
			paymentProgress: paymentProgress
		};
	},
	methods: {
		click() {
			this.$emit("click");
		}
	}
};
</script>

<style lang="scss" scoped>

.status_box {
	width: 40px;
	height: 40px;
	line-height: 40px;
	margin-right: 5px;
	display: flex;
	align-items: center;
	justify-content: center;

	.progress_span {
		display: inline-block;
		width: 25px;
		height: 25px;
		background-color: #BCE1A3;
		vertical-align: center;
	}

	.progress_fully_paid {
		background-color: #BCE1A3;
	}

	.progress_unpaid_before_due_date {
		background-color: #ccc;
	}

	.progress_unpaid_after_due_date {
		background-color: #F33628;
	}

	.progress_partially_paid_before_due_date {
		background-color: #BCE1A3;
		width: 0;
		height: 0;
		border-bottom: 25px solid #FFBE4D;
		border-left: 25px solid transparent;
	}

	.progress_partially_paid_after_due_date {
		background-color: #BCE1A3;
		width: 0;
		height: 0;
		border-bottom: 25px solid #FCAFAC;
		border-left: 25px solid transparent;
	}

	.progress_revoked {
		background-color: #52565C;
	}

	.progress_icon {
		width: 25px;
		height: 25px;
		display: inline-block;
		line-height: 25px;
		text-align: center;
		vertical-align: center;

		i {
			font-size: 25px;
		}
	}
}
</style>